<template>
  <QS-scroller-box>
    <TopPreview :dataList="topPreviewModelList" :model="topPreviewModel" />
    <QS-h4-title title="交接信息" />
    <el-form ref="stockRef" :model="stock" :rules="rulesStock">
      <QS-column-box ref="outInColumnBox" labelWidth="170" :column="2">
        <el-form-item
          prop="actualTakeOverName"
          :label="'提车人姓名' + columnSeparator"
        >
          <el-input
            :disabled="confirmDisabled"
            v-model="stock.actualTakeOverName"
            clearable
            maxlength="20"
            placeholder="请输入提车人姓名"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="actualTakeOverTel"
          :label="'提车人联系电话' + columnSeparator"
        >
          <el-input
            v-model="stock.actualTakeOverTel"
            :disabled="confirmDisabled"
            clearable
            class="lengthen"
            v-number:phone
            placeholder="请输入提车人联系电话"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="takeOverManager"
          :label="'交接车管' + columnSeparator"
        >
          <el-select
            :disabled="confirmDisabled"
            v-model="stock.takeOverManager"
            placeholder="请选择交接车管"
            clearable
            filterable
          >
            <el-option
              v-for="item in carTubeList"
              :label="item.userName"
              :value="item.id"
              :key="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="displayMile" :label="'表显里程' + columnSeparator">
          <el-input
            :disabled="confirmDisabled"
            v-model="stock.displayMile"
            placeholder="请输入表显里程"
            class="lengthen"
            v-number:km
            clearable
          >
            <template slot="append"
              >公里</template
            >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="remainingReserves"
          :label="'剩余电量/油量' + columnSeparator"
          class="remainingReservesFormItem"
        >
          <el-input
            :disabled="confirmDisabled"
            v-model="stock.remainingReserves"
            clearable
            maxlength="20"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="takeOverTime"
          :label="'交接完成时间' + columnSeparator"
        >
          <el-date-picker
            :disabled="confirmDisabled"
            v-model="stock.takeOverTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="请选择交接完成时间"
            class="lengthen"
            clearable
            :picker-options="takeOverTimeOption"
          />
          <p class="form-item-tips-red">
            交接完成时间将影响后续退车核算相关费用，请务必准确填写
          </p>
        </el-form-item>

        <el-form-item prop="hasKey" :label="'车钥匙' + columnSeparator">
          <el-radio-group :disabled="confirmDisabled" v-model="stock.hasKey">
            <el-radio :label="1">有钥匙</el-radio>
            <el-radio :label="0">无钥匙</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="hasCarLicense"
          :label="'行驶证' + columnSeparator"
        >
          <el-radio-group
            :disabled="confirmDisabled"
            v-model="stock.hasCarLicense"
          >
            <el-radio :label="1">有行驶证</el-radio>
            <el-radio :label="0">无行驶证</el-radio>
          </el-radio-group>
          <p class="form-item-tips">
            与车辆标签「无行驶证」关联，选择无行驶证，会自动勾选「无行驶证」标签
          </p>
        </el-form-item>
        <el-form-item
          v-if="isConfirmShow"
          prop="isConfirm"
          :label="'是否需要司机线上验车' + columnSeparator"
        >
          <el-radio-group
            :disabled="isConfirm === 0 || isConfirm === 1"
            v-model="stock.isConfirm"
          >
            <el-radio :label="0">需要</el-radio>
            <el-radio :label="1">不需要</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="'备注' + columnSeparator" class="textare205">
          <el-input
            :disabled="confirmDisabled"
            v-model="stock.remarks"
            type="textarea"
            placeholder="请输入备注"
            maxlength="500"
            show-word-limit
            clearable
          >
          </el-input>
        </el-form-item>
      </QS-column-box>
    </el-form>
    <QS-h4-title title="验车信息" />
    <div class="fileUpload">
      <div class="txt">{{ `验车交接文件${columnSeparator}` }}</div>
      <div>
        <div
          class="imgList"
          v-for="(item, index) in checkCarImgData"
          :key="index"
        >
          <div
            class="imgList_item"
            :class="item.urlList.length == 1 ? 'hideAdd' : ''"
          >
            <UploadCommon
              :fileList="item.urlList"
              :limit="10"
              :sizeType="4"
              :multiple="true"
              fileTitle="最多可上传10张图片（支持批量添加）"
              fileTitleWidth="240px"
              :isAlone="false"
              @uploadSuccess="checkCarImgDataChange"
              @deleteUploadHandle="checkCarImgDataChange"
              commonUpload
              group="vehicle"
              code="vehicle_inspection_file"
            />
          </div>
          <div class="imgList_summay">
            <span>说明:</span>
            <el-input
              style="width:200px;margin-bottom:10px;margin-left:10px"
              v-model="item.remark"
              :disabled="item.urlList.length === 0"
              maxlength="200"
              type="textarea"
              placeholder="请输入内容"
              show-word-limit
              clearable
            />
          </div>
        </div>
      </div>
    </div>
    <div class="photoUpload">
      <div class="txt">{{ `车辆相关照片${columnSeparator}` }}</div>
      <div>
        <div
          class="imgList"
          v-for="(item, index) in aboutCarImgsData"
          :key="index"
        >
          <div :class="item.urlList.length == 3 ? 'hideAdd' : ''">
            <UploadCommon
              :fileList="item.urlList"
              :limit="10"
              :sizeType="4"
              :multiple="true"
              fileTitle="最多可上传10张图片（支持批量添加）"
              fileTitleWidth="240px"
              :isAlone="false"
              @uploadSuccess="isAddImgsItem"
              @deleteUploadHandle="isAddImgsItem"
              commonUpload
              group="order"
              code="order_vehicle_pic"
            />
          </div>
          <div class="imgList_summay">
            <span>说明:</span>
            <el-input
              style="width:200px;margin-bottom:10px;margin-left:10px"
              v-model="item.remark"
              :disabled="item.urlList.length === 0"
              maxlength="200"
              type="textarea"
              placeholder="请输入内容"
              show-word-limit
              clearable
            />
          </div>
        </div>
      </div>
    </div>
    <QS-h4-title title="验车视频" />
    <div class="upload-box">
      <p class="upload-box__title">
        验车视频
        <span class="sub-title-line">（可批量上传最多5个，每个不超过100MB，支持mp4/mov/3gp等视频格式）</span>
      </p>
      <div class="upload-box__content">
        <UploadCommon
          :fileList="inspectionVideoPlus"
          :limit="5"
          :multiple="true"
          :sizeType="4"
          fileTitle="最多上传5个"
          fileTitleWidth="240px"
          :isAlone="false"
          listType="text"
          acceptType=".mp4,.mov,.3gp,.avi,.wmv,.flv,.mkv,.webm"
          commonUpload
          group="vehicle"
          code="vehicle_inspection_file"
        />
      </div>
    </div>
    <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button
        v-if="confirmNext"
        @click="handleConfirm"
        :loading="loading"
        size="mini"
        type="primary"
        >确认，下一步</el-button
      >
      <el-button
        v-if="!confirmNext"
        @click="handleRefresh"
        :loading="loading"
        size="mini"
        type="primary"
        >刷新确认进度</el-button
      >
    </template>
  </QS-scroller-box>
</template>

<script>
// api
import {
  editOutIn,
  getOutInDetails,
  getTempOutInDetails,
  getAllEmployeeList,
} from '@/api/carManage'
import { stockLogFindLastOne } from '@/api/domain/cars'
import { leaseContractOrderDetail } from '@/api/purchaseAndSaleAPI'
// 组件
import TopPreview from '../components/TopPreview'
// 配置
// eslint-disable-next-line import/no-cycle
import publicConfig from '../config'
// 其他
import { formatDate } from '@/utils'
import { validateMobile } from '@/utils/validate'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  components: {
    TopPreview,
  },
  props: {
    topPreviewModel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      stock: {
        displayMile: '',
        takeOverManager: '',
        takeOverTime: '',
        remarks: '',
        actualTakeOverName: '',
        actualTakeOverTel: '',
        remainingReserves: '',
        isConfirm: 0, // 是否需要线上验车, 默认需要
        checkCarSwitch: 0, // 是否需要线上验车开关，1-开启 0-关闭
      },
      loading: false,
      carTubeList: [], // 车管
      // 验车交接文件:
      checkCarImgData: [
        {
          remark: '',
          urlList: [],
        },
      ],
      // 验车视频
      inspectionVideoPlus: [],
      // 车辆相关照片
      aboutCarImgsData: [
        {
          remark: '',
          urlList: [],
        },
      ],
      // 出入库校验
      rulesStock: {
        hasKey: [
          {
            required: true,
            message: '不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        hasCarLicense: [
          {
            required: true,
            message: '不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        displayMile: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        takeOverManager: [
          {
            required: true,
            message: '不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        takeOverTime: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        remarks: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        actualTakeOverName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        actualTakeOverTel: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMobile,
          },
          {
            min: 11,
            max: 11,
            message: '格式不正确',
            trigger: 'blur',
          },
        ],
        remainingReserves: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
      },
      isConfirm: null, // 是否用户确认 null-后台未提交(是否需要司机线上验车) 0-需要 1-无需确认
      orderState: null, // 订单状态
      startTime: '', // 交接完成时间选择范围开始时间
      confirmDisabled: false,
      source: null, // 1-后台下的单 2-商城单  历史单的source字段为空，商城需求上线后的单都带source
      signDate: '', // 交接完成时间选择范围开始时间依赖：签约时间
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    isConfirmShow() {
      // 表单数据长度变更， 重新计算布局
      this.$nextTick(() => {
        this.$refs.outInColumnBox.calcWidth()
      })
    },
  },
  computed: {
    ...mapGetters(['rentMallOpenSwitch']),
    isConfirmShow() {
      return (
        this.rentMallOpenSwitch &&
        this.stock.checkCarSwitch &&
        this.source !== 1
      )
    },
    takeOverTimeOption() {
      /**
       * 出库-1：租赁设置中的签约时间-30天 <= 车辆交接时间 <= 当前时间
       * 入库-2：订单出库时间 <= 车辆交接时间 <= 当前时间
       * */
      const { signDate } = this
      return {
        disabledDate: (time) => {
          return (
            moment(time).isBefore(moment(signDate).subtract(30, 'days')) ||
            moment(time).isAfter(moment())
          )
        },
      }
    },
    confirmNext() {
      if (this.isConfirm === 0) return false
      // 未提交[是否需要司机线上验车]，显示 下一步
      // 已提交[需要司机线上验车] 且 选的是 不需要
      // 服务未返回具体值，一律按 null 的显示逻辑
      return true
    },
    // 顶部预览数据
    topPreviewModelList() {
      const { c_topPreviewList } = publicConfig.call(this)
      return c_topPreviewList
    },
  },
  methods: {
    // 从URL的key参数中提取文件名
    extractFileName(url) {
      if (!url) return ''
      try {
        const queryString = url.split('?')[1] || ''
        const params = new URLSearchParams(queryString)
        const key = params.get('key') || ''
        if (key) {
          return decodeURIComponent(key.split('/').pop() || '')
        }
        return decodeURIComponent(url.split('?')[0].split('/').pop() || '')
      } catch (e) {
        return ''
      }
    },
    // 格式转换文件
    transferCarImgDataChange(allCarImg, num) {
      // 删除中间 剩下有图片的
      const outputArr = allCarImg.filter((item) => {
        return item.urlList.length !== 0
      })

      // 补充 最后一张
      if (outputArr.length < num) {
        outputArr.push({
          remark: '',
          urlList: [],
        })
      }
      return outputArr
    },
    // 车辆相关照片
    isAddImgsItem() {
      this.aboutCarImgsData = this.transferCarImgDataChange(this.aboutCarImgsData, 20)
    },
    // 验车交接文件
    checkCarImgDataChange() {
      this.checkCarImgData = this.transferCarImgDataChange(this.checkCarImgData, 5)
    },
    //  获取车管
    async getCarTubeList() {
      const { code, data } = await getAllEmployeeList()
      if (code === 1) {
        this.carTubeList = data
      }
    },
    // 获取详情
    async getLeaseContractOrderDetail() {
      const { code, data } = await leaseContractOrderDetail({
        orderId: this.topPreviewModel.orderId,
      })
      if (code === 1 && data) {
        const {
          carId,
          deptName,
          customerName,
          planName,
          modelName,
          plateNo,
          rentCategoryName,
          startDate,
          endDate,
          state,
          storeName,
          source,
        } = data

        /* eslint-disable vue/no-mutating-props */
        this.topPreviewModel.deptName = deptName
        this.topPreviewModel.customerName = customerName
        this.topPreviewModel.planName = planName || '自定义'
        this.topPreviewModel.modelName = modelName
        this.topPreviewModel.rentCategoryName = rentCategoryName
        this.topPreviewModel.plateNo = plateNo
        this.topPreviewModel.carId = carId
        this.topPreviewModel.startStopDate = `${startDate}至${endDate}`
        this.topPreviewModel.storeName = storeName
        /* eslint-enable vue/no-mutating-props */
        this.orderState = state
        this.source = source
        //  获取出入库 id 和 是否需要司机线上验车 状态
        this.getStockLogFindLastOne()
      }
    },
    // 回显
    async getOutInDetails(id) {
      const allData = await Promise.allSettled([
        getTempOutInDetails({ id }),
        getOutInDetails({ id }),
      ])
      const tempOutInDetails = allData[0]?.value?.data || {}
      const outInDetails = allData[1]?.value?.data || {}
      this.stock.actualTakeOverName =
        outInDetails.stockInfoVo.actualTakeOverName ||
        tempOutInDetails.actualTakeOverName
      this.stock.actualTakeOverTel =
        outInDetails.stockInfoVo.actualTakeOverTel ||
        tempOutInDetails.actualTakeOverTel
      this.stock.takeOverTime =
        outInDetails.stockInfoVo.takeOverTime ||
        formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
      this.stock.checkCarSwitch = outInDetails?.checkCarSwitch || 0
      this.startTime = outInDetails?.rentOrderVO?.effectDate || ''
      // 已提交待确认
      if (this.isConfirm === 0) {
        this.stock.takeOverManager =
          outInDetails?.stockInfoVo?.takeOverManager || ''
        this.stock.displayMile = outInDetails?.stockInfoVo?.displayMile || ''
        this.stock.remainingReserves =
          outInDetails?.stockInfoVo?.remainingReserves || ''
        this.$set(this.stock, 'hasKey', outInDetails?.stockInfoVo?.hasKey)
        this.$set(
          this.stock,
          'hasCarLicense',
          outInDetails?.stockInfoVo?.hasCarLicense,
        )
        this.confirmDisabled = true
      }
      this.signDate = outInDetails?.rentOrderVO?.signDate || ''
      // 车辆相关照片
      this.aboutCarImgsData = this.imageFilter(outInDetails.stockInfoVo.photo)
      // 验车交接文件
      this.checkCarImgData = this.imageFilter(outInDetails.stockInfoVo.inspectionAttachment)
      // 验车视频
      const videoData = outInDetails.stockInfoVo.inspectionVideo
      if (videoData) {
        const videoList = typeof videoData === 'string' ? JSON.parse(videoData) : videoData
        if (Array.isArray(videoList)) {
          this.inspectionVideoPlus = videoList.map((item, i) => {
            if (typeof item === 'string') {
              return { url: item, name: this.extractFileName(item), uid: `video_${i}`, status: 'success' }
            }
            return { url: item.url || '', name: item.name || this.extractFileName(item.url || ''), uid: item.uid || `video_${i}`, status: 'success' }
          })
        }
      }
    },
    //  获取出入库 id 和 是否需要司机线上验车 状态
    // isConfirm 是否用户确认 null-后台未提交（是否需要司机线上验车） 0-需要 1-无需确认
    async getStockLogFindLastOne() {
      const { data, code } = await stockLogFindLastOne({
        orderId: Number(this.topPreviewModel.orderId),
        carId: this.topPreviewModel.carId,
        state: 0,
        type: 1, // 1 发车验车 2 退车验车
      })
      // data 返回null，可能是其中两种情况，一种是订单未创建，一种是订单已完成，所以需要结合订单的状态具体判断
      if (code === 1) {
        const { id, isConfirm } = data || {}
        // eslint-disable-next-line vue/no-mutating-props
        this.topPreviewModel.stockId = id || null
        id && this.getOutInDetails(id)
        this.isConfirm = isConfirm
        if (isConfirm === 0) {
          this.$message.info('司机确认中，请稍等！')
        }
        // 出入库查询出的data为null，且订单状态为2500（待履约），代表车辆出库完成，(3500-退车待验车、4500-订单待核算、5500-已关闭)直接跳转到下一步
        if (
          !data &&
          (Number(this.orderState) === 2500 || Number(this.orderState) > 2500)
        ) {
          // 用户确认完成，跳转到下一步
          this.toGoNextStep()
        }
      }
    },
    // 取消
    cancel() {
      this.$confirm(
        '是否确认退出创建个人签约提车流程?退出后可在"待租车辆列表-个人租赁订单-发车待验车"状态下找到订单并继续',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).then(() => {
        this.$emit('cancel')
      }).catch(() => null)
    },
    handleRefresh() {
      this.handleConfirm()
    },
    // 选择【需要司机线上验车】，弹窗提示 验车节点的流转 逻辑
    isConfirmVerifyDialog() {
      return new Promise((resolve) => {
        this.$confirm(
          '提交后，需等待司机确认验车信息，用户未完成前，流程仍停留在“发车验车”节点',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )
          .then(() => {
            resolve({
              code: 1,
            })
          })
          .catch(() => {
            resolve({
              code: 0,
            })
          })
      })
    },
    // 确认
    async handleConfirm() {
      // 表单校验
      let validFlag = false
      this.$refs.stockRef.validate((valid) => {
        validFlag = valid
      })
      if (!validFlag) {
        this.$message.error('请填写必填项')
        return false
      }
      // 如果选的是【需要司机线上验车】,且是首次提交是否需要司机线上验车（也就是isConfirm 为 null）,source --1:后台下单
      if (
        this.rentMallOpenSwitch &&
        this.isConfirm === null &&
        Number(this.stock.isConfirm) === 0 &&
        this.source !== 1
      ) {
        const { code } = await this.isConfirmVerifyDialog()
        if (code === 1) {
          this.submitData() // 提交表单
        }
      } else {
        this.submitData() // 提交表单
      }
    },
    async submitData() {
      if (this.loading) return
      const data = this.parseSendData()
      // 商城关闭，删除 isConfirm
      if (!this.rentMallOpenSwitch) {
        delete data.isConfirm
      }
      if (this.source === 1) {
        data.isConfirm = 1 // 后台单不需要线上验车
      }
      // 出入库id为空，重新查询一下出入库状态
      if (!data.id) {
        this.getLeaseContractOrderDetail() // 请求订单详情同时刷新车主端的确认状态
        return
      }
      this.loading = true
      const { code } = await editOutIn(data).catch(() => {
        this.loading = false
        // 如果是其他异常情况（如订单状态实际已流转），需重新获取下订单详情，保证可以正常跳转到下一步，不会阻塞流程
        this.getLeaseContractOrderDetail() // 请求订单详情同时刷新车主端的确认状态
      })
      this.loading = false
      if (code === 1) {
        // 如果选的是【需要司机线上验车，需要等待车主端的司机确认状态】
        if (this.isConfirm === null && Number(this.stock.isConfirm) === 0) {
          this.$message.success('添加成功')
          this.isConfirm = 0
          this.getLeaseContractOrderDetail() // 请求订单详情同时刷新车主端的确认状态
          return
        }
        // 如果选的是【需要司机线上验车，需要等待车主端的司机确认状态】
        if (this.isConfirm === 0 && Number(this.stock.isConfirm) === 0) {
          this.isConfirm = 0
          this.getLeaseContractOrderDetail() // 请求订单详情同时刷新车主端的确认状态
          return
        }
        if (this.isConfirm === 1 && Number(this.stock.isConfirm) === 1) {
          // 已提交不需要，当前选的也是不需要，直接跳转到下一步
          this.toGoNextStep()
          return
        }
        if (this.isConfirm === null && Number(this.stock.isConfirm) === 1) {
          // 选的是不需要，直接跳转到下一步
          this.toGoNextStep()
        }
      }
    },
    // 跳转到下一步
    toGoNextStep() {
      this.$refreshParent()
      this.$router.replace({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
        query: {
          stepsActive: 5,
          orderId: this.topPreviewModel.orderId,
        },
      })
    },
    // 提交需要转换数据
    parseSendData() {
      const sendObj = { ...this.stock }
      sendObj.displayMile = Number(sendObj.displayMile)
      sendObj.takeOverManager = Number(sendObj.takeOverManager)
      sendObj.carId = this.topPreviewModel.carId
      sendObj.type = 1 // 1出库 2入库 3采购入库
      sendObj.id = Number(this.topPreviewModel.stockId)

      if (this.checkCarImgData.length) {
        let result = this.checkCarImgData?.map((item) => {
          const obj = { ...item }
          obj.urlList = item?.urlList.map((it) => it.url)
          return obj
        })
        result = result.filter((item) => item.urlList.length > 0).map((item) => item)
        sendObj.inspectionAttachment = JSON.stringify(result)
      } else {
        sendObj.inspectionAttachment = null
      }
      if (this.aboutCarImgsData.length) {
        let result = this.aboutCarImgsData?.map((item) => {
          const obj = { ...item }
          obj.urlList = item?.urlList.map((it) => it.url)
          return obj
        })
        result = result.filter((item) => item.urlList.length > 0).map((item) => item)
        sendObj.photo = JSON.stringify(result)
      } else {
        sendObj.photo = null
      }
      if (this.inspectionVideoPlus.length) {
        sendObj.inspectionVideo = this.inspectionVideoPlus.map((item) => item.url)
      } else {
        sendObj.inspectionVideo = []
      }
      return sendObj
    },
    init() {
      // 获取订单详情
      this.getLeaseContractOrderDetail()
      // 获取车管
      this.getCarTubeList()
    },
    // 图片处理
    imageFilter(data) {
      if (!data) return [{ remark: '', urlList: [] }]
      let result
      try {
        result = JSON.parse(data)
      } catch (error) {
        result = data
      }

      Array.isArray(result) && result.forEach((item) => {
        item.urlList = this.getEchoUploadFileData(item?.urlList, true)
      })
      result = result && result.length > 0 ? result : [{ remark: '', urlList: [] }]
      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.item,
.info,
.dialogwrap-add {
  ::v-deep .el-input--small {
    width: 205px;
  }
}

.float-right {
  float: right;
}

.sumbit-btns {
  text-align: center;
}
.fileUpload {
  display: flex;

  .txt {
    padding-right: 12px;
    width: 149px;
    box-sizing: border-box;
    text-align: right;
    color: #333;
  }
}

.photoUpload {
  margin-top: 15px;
  display: flex;

  .txt {
    padding-right: 12px;
    width: 149px;
    box-sizing: border-box;
    text-align: right;
  }
}

.uploadCommon_container {
  display: flex;
}

.imgList {
  padding-right: 12px;
  box-sizing: border-box;
  text-align: right;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 30px;
  .imgList_summay {
    display: flex;
    align-items: flex-start;
  }
}

.form-item-tips {
  font-size: 12px;
  color: #666;
  line-height: 20px;
}
.form-item-tips-red {
  font-size: 12px;
  color: red;
  line-height: 20px;
}

.lengthen {
  width: 230px;
}

::v-deep .remainingReservesFormItem .el-form-item__error {
  position: relative;
  top: 0;
}
::v-deep .bottom-action-inner {
  bottom: 12px;
}
.upload-box {
  padding-bottom: 10px;
  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #1D2129;
    .sub-title-line {
      color: #4E5969;
      font-weight: 400;
    }
  }
  &__content {
    &__subtitle {
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      color: #86909C;
    }
  }
}
</style>
